import React, { useState, useEffect, useRef, act } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AiNavbar from "../../components/AiNavbar";
import Sidebar from "../../components/Sidebar";
import Content from "../../components/Content";
import AiAssistant from "./AiAssistant";
import ExternalUser from "./ExternalUser";
import ChatHistory from "./ChatHistory";
import { Grid } from "semantic-ui-react";
import "../../styles/AiAssistant.css";
import CustomToaster from "../../components/CustomToaster";
import RetrievalParameter from "../Dataconsole/RetrievalParameter";
import { getDataSetParameters } from "../../apis"; // Import the API function
import AssistantSettings from "../Dataconsole/AssistantSettings"; // Import the AssistantSettings component
import FilesTab from "../../components/FilesTab";

const Index = ({ pageID, title, userType }) => {
  const [toggleBtn, setToggleBtn] = useState(false);
  const [filterPopUp, setFilterPopUp] = useState(false);
  const [dataFromChild, setDataFromChild] = useState(null);
  const [filterdataFromChild, setFilterDataFromChild] = useState(null);
  const [clearFilterFromChild, setClearFilterFromChild] = useState(false);
  const [resetFilterStartDate, setResetFilterStartDate] = useState(false);
  const [isFilterPopUpClick, setIsFilterPopUpClick] = useState(false);
  const [navTitle, setnavTitle] = useState(title || "Ai Assistant"); // Use title prop
  const location = useLocation();
  const [isQuickChatMode, setIsQuickChatMode] = useState(false);
  const [quickChatType, setQuickChatType] = useState("");
  const [clearFilterPopUp, setClearFilterPopUp] = useState(false);
  const [checkClicked, setCheckClicked] = useState(false);
  const [isChatHistory, setIsChatHistory] = useState(false);
  const [chatHistoryLoaded, setChatHistoryLoaded] = useState(false);
  const [eventName, setEventName] = useState("");
  const [eventId, setEventId] = useState("");
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [ChatHistoryOpen, setChatHistoryOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("chatHistory");
  const [datasetData, setDatasetData] = useState(null); // New state for dataset data
  const [isLoading, setIsLoading] = useState(false); // Loading state for fetching data
  const [datasetId, setDatasetId] = useState(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const idFromUrl = urlParams.get('c');
    console.log('AiAssistant index - Initial datasetId setup:', idFromUrl);
    return idFromUrl || null;
  });
  const [params, setParams] = useState({ datasetId });
  const [changeParams, setChangeParams] = useState({});
  const [assistantParams, setAssistantParams] = useState({}); // New state for AssistantSettings real-time data
  const [isChatView, setIsChatView] = useState(false);
  const [isFilterButtonClicked, setIsFilterButtonClicked] = useState(false);
  const [isHandleViewCalled, setHandleViewCalled] = useState(false); // New state
  const [isAssistantDataset, setIsAssistantDataset] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [documentCount, setDocumentCount] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isAgentSessionActive, setIsAgentSessionActive] = useState(false);
  const [agentRequestStatus, setAgentRequestStatus] = useState(null);
  const quitAgentFnRef = useRef(null);
  const [chatViewPreference, setChatViewPreference] = useState(
    () => localStorage.getItem("chatViewPreference") || "same-side"
  );
  const handleChatViewChange = (preference) => {
    setChatViewPreference(preference);
    localStorage.setItem("chatViewPreference", preference);
  };
  const currentUserType = useSelector((state) => state.auth.user);
  const orgDetails = useSelector((state) => state.admin.details);

  const { responseRadioDataList } = useSelector(
    (state) => state.listDatasetRadioReducer || {}
  );
  // Apply external-user / human-agent body class for theming
  useEffect(() => {
    if (currentUserType === "ExternalUser") {
      document.body.classList.add("external-user");
    } else {
      document.body.classList.remove("external-user");
    }
    if (currentUserType === "HumanAgent") {
      document.body.classList.add("human-agent");
    } else {
      document.body.classList.remove("human-agent");
    }
    return () => {
      document.body.classList.remove("external-user");
      document.body.classList.remove("human-agent");
    };
  }, [currentUserType]);

  // Close fullscreen on Escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && isFullscreen) setIsFullscreen(false);
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isFullscreen]);

  // Toggle sidebar visibility in fullscreen mode
  useEffect(() => {
    if (isFullscreen) {
      document.body.classList.add("chat-fullscreen");
    } else {
      document.body.classList.remove("chat-fullscreen");
    }
    return () => document.body.classList.remove("chat-fullscreen");
  }, [isFullscreen]);

  const handleViewCalled = () => {
    setHandleViewCalled(true);
    setTimeout(() => {
      setHandleViewCalled(false);
    }, 3000);
  };

  const onParamsChange = (newParams) => {
    setChangeParams(newParams);
  };

  const onAssistantParamsChange = (newParams) => {
    setAssistantParams(newParams); // Update real-time data from AssistantSettings
  };

  const saveParams = (id, newParams) => {
    setParams((prevParams) => ({
      ...prevParams,
      [id]: newParams,
    }));
  };

  // Quick chat detection useEffect - runs when URL changes
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const quickChatParam = urlParams.get("quickChat");
    const methodParam = urlParams.get("method");
    const isQuickChat = quickChatParam === "1" && (methodParam === "quickChat" || methodParam === "assistantQuickChat");
    
    setIsQuickChatMode(isQuickChat);
    
    if (isQuickChat) {
      const type = methodParam === "assistantQuickChat" ? "Assistant" : "Standard";
      setQuickChatType(type);
      
      // For standard Quick Chat, ensure agenticQnAEnabled is set to true
      if (methodParam === "quickChat") {
        setChangeParams(prev => ({
          ...prev,
          agenticQnAEnabled: true
        }));
      }
    } else {
      setQuickChatType("");
      // Reset changeParams when not in quick chat mode
      setChangeParams({});
    }
  }, [location.search]);

  // For ExternalUser only, ensure no existing chat id (cid) persists on (re)load.
  // Normal users retain the same chat by keeping cid.
  useEffect(() => {
    if (currentUserType !== 'ExternalUser') return;
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has('cid')) {
        url.searchParams.delete('cid');
        window.history.replaceState({}, document.title, url.toString());
      }
    } catch (e) {
      // ignore
    }
  }, [currentUserType]);

// Update datasetId when URL changes
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const idFromUrl = urlParams.get('c');
    // Only update if URL has a dataset ID - don't reset to null
    // This allows handleDatasetSelected to set datasetId without being overwritten
    if (idFromUrl && idFromUrl !== datasetId) {
      setDatasetId(idFromUrl);
    }
  }, [location.search]); // Removed datasetId from dependencies to prevent loop

  // Title update useEffect
  useEffect(() => {
    if (title) {
      if (isQuickChatMode && quickChatType) {
        // For all users in quickchat mode, use the same label as sidebar
        const fullOrgName = orgDetails?.orgName || "Innover";
        const quickChatLabel = orgDetails?.quickChatLabel;

        if (quickChatLabel) {
          setnavTitle(quickChatLabel);
        } else {
          setnavTitle(`${fullOrgName} Assistant`);
        }
      } else {
        setnavTitle(title);
      }
    }
  }, [title, isQuickChatMode, quickChatType, currentUserType, orgDetails]);
  

  // const checkIsAssistantDataset = (datasetId) => {
  //   if (responseRadioDataList && responseRadioDataList.length > 0) {
  //     const dataset = responseRadioDataList.find(
  //       (item) => item.id === datasetId
  //     );
  //     if (dataset) {
  //       setIsAssistantDataset(dataset.isAssistantDataset || false);
  //     } else {
  //       setIsAssistantDataset(false);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   if (datasetId) {
  //     checkIsAssistantDataset(datasetId);
  //   }
  // }, [datasetId, responseRadioDataList]);

  useEffect(() => {
    if (activeTab === "chatHistory") {
      setIsChatView(false);
    }
  }, [activeTab]);

  useEffect(() => {
    if (!datasetId || responseRadioDataList.length === 0) return;
  
    const dataset = responseRadioDataList.find((item) => item.id === datasetId);
    const isAssistant = dataset?.isAssistantDataset || false;
  
    // Only update state if the value actually changed to prevent infinite loops
    setIsAssistantDataset((prev) => {
      if (prev !== isAssistant) {
        return isAssistant;
      }
      return prev;
    });
  
    setActiveTab((prevTab) => {
      if (prevTab !== "chatHistory") {
        return isAssistant ? "assistantSettings" : "retrievalParameter";
      }
      return prevTab;
    });
  }, [datasetId, responseRadioDataList]);
  

  const handleDatasetSelected = (id) => {
    setDatasetId(id);

    // Dynamically determine tab based on assistant flag
    const dataset = responseRadioDataList.find((item) => item.id === id);
    const isAssistant = dataset?.isAssistantDataset || false;
  
    setIsAssistantDataset(isAssistant);
  
    // Only update activeTab if it's not currently "chatHistory"
    setActiveTab((prevTab) => {
      if (prevTab !== "chatHistory") {
        return isAssistant ? "assistantSettings" : "retrievalParameter";
      }
      return prevTab; // leave it unchanged if it's chatHistory
    });
  };
  

  const toggle = () => setToggleBtn((val) => !val);

  const handleFilterSort = () => {
    setFilterPopUp(!filterPopUp);
    setResetFilterStartDate(!filterPopUp ? false : "");
    setIsFilterButtonClicked(true);
  };

  const handleTabSelect = (tab) => {
    setActiveTab(tab);
  };

  const handleChatHistoryOpen = () => {
    setChatHistoryOpen(!ChatHistoryOpen);
    setIsChatView(false);
  };

  const handleDataFromChild = (data) => {
    setDataFromChild(data);
  };

  const handleFilteredDataFromChild = (data) => {
    setFilterDataFromChild(data);
    setClearFilterFromChild(data.filter);
  };

  const clearFilterFromChildFunc = (data) => {
    setClearFilterFromChild(data);
    setClearFilterPopUp(true);
  };

  const reverseFilteringFromSD = (data) => {
    setResetFilterStartDate(data);
  };

  const checkFilterPopUP = (flag) => {
    setIsFilterPopUpClick(flag);
    setClearFilterFromChild(true);
  };

  const handleOutsideClick = (data) => {
    setCheckClicked(true);
  };

  const checkChatHistoryCreation = (flag) => {
    setIsChatHistory(flag);
  };

  const updateOutsideFunc = (data) => {
    setEventName(data.event);
    setEventId(data.eventId);
  };

  const showToaster = (message, appearance) => {
    setToasterVisible(true);
    setToasterMessage(message);
    setToasterAppearance(appearance);
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };

  const handleCloseButtonClick = () => {
    setToggleBtn(false);
  };

  const handleClearFilter = () => {
    setIsFilterButtonClicked(false);
  };

  const handleUploadedFilesChange = (files) => {
    console.log('Index: received uploaded files:', files);
    setUploadedFiles(files);
  };

  const handleFileRemoval = (fileId) => {
    console.log('Index: removing file:', fileId);
    setUploadedFiles(prev => prev.filter(file => {
      const documentId = file._id || file.id;
      return documentId !== fileId;
    }));
  };

  return (
    <div className="top-wrapper">
      {currentUserType !== "ExternalUser" && currentUserType !== "HumanAgent" && (
        <Sidebar toggleBtn={toggleBtn} onCloseButtonClick={handleCloseButtonClick} />
      )}
      <AiNavbar
        setToggle={toggle}
        navTitle={navTitle}
        type={pageID}
        handleFilterSort={handleFilterSort}
        handleChatHistoryOpen={handleChatHistoryOpen}
        ChatHistoryOpen={ChatHistoryOpen}
        onTabSelect={handleTabSelect}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        setChatHistoryOpen={setChatHistoryOpen} // Pass the function as a prop
        datasetId={datasetId} // Pass the dataset
        isAssistantDataset={isAssistantDataset} // Pass the value to AiNavbar
        uploadedFiles={uploadedFiles} // Pass uploaded files for Files tab
        documentCount={documentCount} // Pass actual document count from API
        isFullscreen={isFullscreen}
        onToggleFullscreen={() => setIsFullscreen(!isFullscreen)}
        chatViewPreference={chatViewPreference}
        onChatViewChange={handleChatViewChange}
        showQuitAgent={isAgentSessionActive}
        onQuitAgent={() => quitAgentFnRef.current?.()}
        agentRequestStatus={agentRequestStatus}
      />
      <Content toggleBtn={toggleBtn}>
        {toasterVisible && (
          <CustomToaster
            message={toasterMessage}
            duration={3000}
            onClose={closeToaster}
            position="right-top"
            appearance={toasterAppearance}
          />
        )}
        {/* For mobile outside of grid */}
        {currentUserType != "ExternalUser" && ChatHistoryOpen  && (
          <grid className="mobile-grid-view">
            {activeTab === "chatHistory" && !isChatView && (
              <ChatHistory
                dataFromChild={dataFromChild}
                filterdataFromChild={filterdataFromChild}
                onClearFilteredFromChild={clearFilterFromChildFunc}
                clearFilterFromChild={clearFilterFromChild}
                onStartDateClear={reverseFilteringFromSD}
                isFilterPopUpClick={isFilterPopUpClick}
                handleFilterSort={handleFilterSort}
                onOutsideClick={handleOutsideClick}
                isChatHistory={isChatHistory}
                isChatHistoryCreated={checkChatHistoryCreation}
                chatHistoryLoaded={chatHistoryLoaded}
                setChatHistoryLoaded={setChatHistoryLoaded}
                updateOutsideFunc={updateOutsideFunc}
                eventName={eventName}
                eventId={eventId}
                showToaster={showToaster}
                ChatHistoryOpen={ChatHistoryOpen}
                setIsChatView={setIsChatView}
                setHandleViewCalled={setHandleViewCalled}
                handleViewCalled={handleViewCalled}
                closeMobileChatHistory={handleChatHistoryOpen}
              />
            )}
            {currentUserType !== "HumanAgent" && activeTab === "retrievalParameter" && (
              <RetrievalParameter
                datasetId={datasetId}
                saveParams={saveParams}
                params={params}
                onParamsChange={onParamsChange}
                userType={userType}
                setIsLoading={setIsLoading} // Pass setIsLoading
                isLoading={isLoading} // Pass isLoading
              />
            )}
            {currentUserType !== "HumanAgent" && activeTab === "assistantSettings" && (
              <AssistantSettings
                datasetId={datasetId}
                setIsLoading={setIsLoading}
                isLoading={isLoading}
                onAssistantParamsChange={onAssistantParamsChange} // Pass the handler
              />
            )}
            {currentUserType !== "HumanAgent" && activeTab === "files" && isQuickChatMode && (
              <FilesTab
                uploadedFiles={uploadedFiles}
                showToaster={showToaster}
                datasetId={datasetId}
                onRemoveFile={handleFileRemoval}
                onFilesUpdate={setUploadedFiles}
                onDocumentCountChange={setDocumentCount}
              />
            )}
          </grid>
        )}
        {/* mobile view end */}
        {(!ChatHistoryOpen || isFilterButtonClicked) && (
          <Grid columns={currentUserType === "ExternalUser" ? 1 : 2} divided={false} stackable>
            <Grid.Row className="chatWithHistory">
              <Grid.Column className="ai-chat-grid" width={currentUserType === "ExternalUser" ? 16 : undefined}>
                {isFullscreen && (
                  <button className="fullscreen-exit-btn" onClick={() => setIsFullscreen(false)} title="Exit Full Screen">
                    &times;
                  </button>
                )}
                {currentUserType === "ExternalUser" ? (
                  <ExternalUser />
                ) : (
                  <AiAssistant
                    filterPopUp={filterPopUp}
                    setFilterPopUp={setFilterPopUp}
                    onDataFromChild={handleDataFromChild}
                    onFilteredDataFromChild={handleFilteredDataFromChild}
                    resetFilterStartDate={resetFilterStartDate}
                    isFilterPopUpClick={checkFilterPopUP}
                    isClearFiltered={clearFilterPopUp}
                    isChatHistoryCreated={checkChatHistoryCreation}
                    datasetData={datasetData}
                    isLoading={isLoading}
                    onDatasetSelect={handleDatasetSelected}
                    saveParams={params}
                    changeParams={changeParams}
                    handleClearFilter={handleClearFilter}
                    isHandleViewCalled={isHandleViewCalled}
                    isAssistantDataset={isAssistantDataset}
                    assistantParams={assistantParams}
                    onUploadedFilesChange={handleUploadedFilesChange}
                    setActiveTab={setActiveTab}
                    chatViewPreference={chatViewPreference}
                    onAgentActiveChange={setIsAgentSessionActive}
                    onAgentRequestStatusChange={setAgentRequestStatus}
                    quitAgentFnRef={quitAgentFnRef}
                  />
                )}
              </Grid.Column>
              {currentUserType != "ExternalUser" && (
              <Grid.Column className="ai-history-grid">
                {activeTab === "chatHistory" && !isChatView && (
                  <ChatHistory
                    dataFromChild={dataFromChild}
                    filterdataFromChild={filterdataFromChild}
                    onClearFilteredFromChild={clearFilterFromChildFunc}
                    clearFilterFromChild={clearFilterFromChild}
                    onStartDateClear={reverseFilteringFromSD}
                    isFilterPopUpClick={isFilterPopUpClick}
                    handleFilterSort={handleFilterSort}
                    onOutsideClick={handleOutsideClick}
                    isChatHistory={isChatHistory}
                    isChatHistoryCreated={checkChatHistoryCreation}
                    chatHistoryLoaded={chatHistoryLoaded}
                    setChatHistoryLoaded={setChatHistoryLoaded}
                    updateOutsideFunc={updateOutsideFunc}
                    eventName={eventName}
                    eventId={eventId}
                    showToaster={showToaster}
                    ChatHistoryOpen={ChatHistoryOpen}
                    setHandleViewCalled={setHandleViewCalled}
                    handleViewCalled={handleViewCalled}
                    isAssistantDataset={isAssistantDataset} // Pass the value to AiNavbar
                  />
                )}
                {currentUserType !== "HumanAgent" && activeTab === "retrievalParameter" && (
                  <RetrievalParameter
                    datasetId={datasetId}
                    saveParams={saveParams}
                    params={params}
                    onParamsChange={onParamsChange}
                    userType={userType}
                    setIsLoading={setIsLoading} // Pass setIsLoading
                    isLoading={isLoading} // Pass isLoading
                  />
                )}
                {currentUserType !== "HumanAgent" && activeTab === "assistantSettings" && (
                  <AssistantSettings
                    datasetId={datasetId}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    onAssistantParamsChange={onAssistantParamsChange} // Pass the handler
                  />
                )}
                {currentUserType !== "HumanAgent" && activeTab === "files" && isQuickChatMode && (
                  <FilesTab
                    uploadedFiles={uploadedFiles}
                    showToaster={showToaster}
                    datasetId={datasetId}
                    onRemoveFile={handleFileRemoval}
                    onFilesUpdate={setUploadedFiles}
                    onDocumentCountChange={setDocumentCount}
                  />
                )}
              </Grid.Column>
              )}
            </Grid.Row>
          </Grid>
        )}
      </Content>
    </div>
  );
};

export default Index;



